import React from "react";
import { ContentGrid, Grid2, Grid3, Grid4, SectionBox } from "../styles";
import { Card, Button, Field, Pill } from "../components";
import Icon from "../components/Icon";

const AddressesView = ({
  companyName,
  setCompanyName,
  companyVat,
  setCompanyVat,
  companyRegNo,
  setCompanyRegNo,
  regAddress1,
  setRegAddress1,
  regAddress2,
  setRegAddress2,
  regCity,
  setRegCity,
  regState,
  setRegState,
  regZip,
  setRegZip,
  regCountry,
  setRegCountry,
  shipName,
  setShipName,
  shipPhone,
  setShipPhone,
  shipAddress1,
  setShipAddress1,
  shipAddress2,
  setShipAddress2,
  shipCity,
  setShipCity,
  shipState,
  setShipState,
  shipZip,
  setShipZip,
  shipCountry,
  setShipCountry,
  pushToast,
  uid,
  setAudit,
  addressLoading,
  saveAddressInfo,
}) => {
  const buildMarketplaceProfile = () => {
    return {
      company: {
        legalName: companyName,
        vatOrTaxId: companyVat,
        registrationNo: companyRegNo,
      },
      registeredAddress: {
        address1: regAddress1,
        address2: regAddress2,
        city: regCity,
        state: regState,
        zip: regZip,
        country: regCountry,
      },
      shippingAddress: {
        receiverName: shipName,
        phone: shipPhone,
        address1: shipAddress1,
        address2: shipAddress2,
        city: shipCity,
        state: shipState,
        zip: shipZip,
        country: shipCountry,
      },
    };
  };

  return (
    <ContentGrid>
      <Card title="Marketplace Profile" icon="map" right={<Pill tone="d">Company + Registered + Shipping</Pill>}>
        <ContentGrid>
          <Grid3>
            <Field label="Company legal name" value={companyName} onChange={setCompanyName} />
            <Field label="Registration no." value={companyRegNo} onChange={setCompanyRegNo} />
            <Field label="VAT / Tax ID" value={companyVat} onChange={setCompanyVat} />
          </Grid3>

          <SectionBox>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10 }}>
              <div style={{ fontWeight: 900 }}>Registered / Billing address</div>
              <Pill tone="c">Invoices</Pill>
            </div>
            <Grid2>
              <Field label="Address 1" value={regAddress1} onChange={setRegAddress1} />
              <Field label="Address 2" value={regAddress2} onChange={setRegAddress2} placeholder="(optional)" />
            </Grid2>
            <Grid4>
              <Field label="City" value={regCity} onChange={setRegCity} />
              <Field label="State/Province" value={regState} onChange={setRegState} />
              <Field label="ZIP" value={regZip} onChange={setRegZip} />
              <Field label="Country" value={regCountry} onChange={setRegCountry} />
            </Grid4>
          </SectionBox>

          <SectionBox>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10 }}>
              <div style={{ fontWeight: 900 }}>Shipping address</div>
              <Pill tone="d">Marketplace default</Pill>
            </div>
            <Grid3>
              <Field label="Receiver" value={shipName} onChange={setShipName} />
              <Field label="Phone" value={shipPhone} onChange={setShipPhone} />
              <div />
            </Grid3>
            <Grid2>
              <Field label="Address 1" value={shipAddress1} onChange={setShipAddress1} />
              <Field label="Address 2" value={shipAddress2} onChange={setShipAddress2} placeholder="(optional)" />
            </Grid2>
            <Grid4>
              <Field label="City" value={shipCity} onChange={setShipCity} />
              <Field label="State/Province" value={shipState} onChange={setShipState} />
              <Field label="ZIP" value={shipZip} onChange={setShipZip} />
              <Field label="Country" value={shipCountry} onChange={setShipCountry} />
            </Grid4>
          </SectionBox>

          <div style={{ display: "flex", justifyContent: "space-between", gap: 10, flexWrap: "wrap" }}>
            <Button
              variant="sec"
              disabled={addressLoading}
              onClick={async () => {
                const payload = buildMarketplaceProfile();
                if (saveAddressInfo) {
                  await saveAddressInfo(payload);
                } else {
                  pushToast("Marketplace", "Profile saved (payload ready)");
                  setAudit((s) => [{ id: uid(), ts: "2026-01-08 09:18", actor: "user", type: "Marketplace", detail: "Marketplace profile updated", severity: "low" }, ...s]);
                  console.log("marketplaceProfile payload", payload);
                }
              }}
              icon="check"
            >
              {addressLoading ? "Saving…" : "Save marketplace profile"}
            </Button>
            <Pill tone="d">Payload ready for backend</Pill>
          </div>
        </ContentGrid>
      </Card>
    </ContentGrid>
  );
};

export default AddressesView;
